import { useRouteError } from 'react-router';

import { ErrorFallback } from '@/component';

const ErrorPage = () => {
  const error = useRouteError() as Error;

  return (
    <ErrorFallback
      code={
        Object.hasOwn(error.cause ?? {}, 'code')
          ? (error.cause as any).code
          : 404
      }
      error={error}
      onRefresh={() => {
        location.reload();
      }}
    />
  );
};

export default ErrorPage;
